module.exports = __webpack_public_path__ + "static/img/local.340119b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img/local.png
// module id = 2kV1
// module chunks = 0